import React from "react";
import { useSelector } from "react-redux";
import { selectedArticles } from "../../../../../../../../../store/Concept/selectors";
import { isSelected } from "../../../../../../../../../utils/functions";
import TextField from "../../../../../Input";
import { Container, Wrapper } from "./styled";

const EditCell = ({ handleChange, row, name, defVal }) => {
  const items = useSelector(selectedArticles);
  const disabled = !isSelected(items, row.original.id);

  if (row.canExpand) {
    return null;
  }

  return (
    <Wrapper>
      <Container>
        <TextField handleChange={handleChange} row={row} name={name} defVal={defVal} disabled={disabled} />
      </Container>
    </Wrapper>
  );
};

export default EditCell;
